<template>
  <div class="home">
    <EbHeading level="h1" class="eb-page-heading">Déclarer un accueil supplémentaire</EbHeading>
    
    <div class="eb-content-default">
      
      <form action="#" @submit.prevent="sendDeclaration">
        <EbInput label="À compter du (jj/mm/aaaa)" type="date" required v-model="dateDebut"></EbInput>
        
        <EbInput label="Nom de l’enfant" v-model="accueilSupplementairePonctuel.nomEnfant" required></EbInput>
        <EbInput label="Prénom de l’enfant" v-model="accueilSupplementairePonctuel.prenomEnfant" required></EbInput>
        
        <EbInput label="Date de naissance de l’enfant (jj/mm/aaaa)" type="date" required v-model="accueilSupplementairePonctuel.dateNaissanceEnfant"></EbInput>
        
        <EbTextarea label="Dates et horaires d’accueil" :rows="8" width="expand" v-model="accueilSupplementairePonctuel.datesHorairesAccueil" required></EbTextarea>
        
        <fieldset>
          <legend>Coordonnées du premier parent</legend>
          <EbInput label="Nom et prénom du parent" v-model="accueilSupplementairePonctuel.nomParent1" required></EbInput>
          <EbTextarea label="Adresse du parent" v-model="accueilSupplementairePonctuel.adresseParent1" required></EbTextarea>
          <EbInput type="tel" label="Téléphone du parent" v-model="accueilSupplementairePonctuel.telephoneParent1" required></EbInput>
        </fieldset>
        
        <EbDisclosure v-model="hasParent2" label="Déclarer des coordonnées différentes pour le deuxième parent" isSwitch groupTag="fieldset" legend="Coordonnées du deuxième parent">
          <EbInput label="Nom et prénom du parent" v-model="accueilSupplementairePonctuel.nomParent2" :required="hasParent2?true:null"></EbInput>
          <EbTextarea label="Adresse du parent" v-model="accueilSupplementairePonctuel.adresseParent2" :required="hasParent2?true:null"></EbTextarea>
          <EbInput type="tel" label="Téléphone du parent" v-model="accueilSupplementairePonctuel.telephoneParent2" :required="hasParent2?true:null"></EbInput>
        </EbDisclosure>
        
        <EbButton type="submit">Envoyer la déclaration</EbButton>
      </form>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'accueilDerogatoire',
  data() {
    return {
      accueilSupplementairePonctuel: {
        nomEnfant: null,
        prenomEnfant: null,
        dateNaissanceEnfant: null,
        datesHorairesAccueil: null,
        
        nomParent1: null,
        adresseParent1: null,
        telephoneParent1: null,
        nomParent2: null,
        adresseParent2: null,
        telephoneParent2: null
      },
      dateDebut: null,
      hasParent2: false
    }
  },
  methods: {
    sendDeclaration: async function() {
      await this.$http
      .post('assmat/enfants/nouvelAccueil/derogatoire', {
        accueilSupplementairePonctuel: this.accueilSupplementairePonctuel,
        dateDebut: this.dateDebut
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status: 'create'}})
      })
      .catch(error => {
        this.errorOnSave = true
        this.bannerTimestamp = this.getTime()
      })
    },
  }
}
</script>
